/**
 * @file Component to present the forecast
 * @author Tzi Yang Lum
 */
import * as tslib_1 from "tslib";
import { AfterContentChecked, OnDestroy, ChangeDetectorRef, AfterViewInit, NgZone, ElementRef } from '@angular/core';
import { AlertsService } from '../../../core/alerts.service';
import { LocalisationService } from '../../../core/localisation.service';
import { EventsService } from '../../../core/event.service';
import { DomainService } from '../../../domain.service';
import { ExecutorsService } from '../../executors.service';
import { SettingsService } from '../../../settings.service';
import { GridService } from '../../grid.service';
import { PluginViewShiftsComponent } from '../plugin-view-shifts/plugin-view-shifts.component';
/**
 * Class to show the forecast, the unplanned attendants only.
 */
var PluginViewAttendantsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PluginViewAttendantsComponent, _super);
    /**
     * Creates an instance of PluginViewAttendantsComponent.
     * @param {LocalisationService} localisationService LocalisationService to get langauge dependent formats.
     * @param {ChangeDetectorRef} changeDetector ChangeDetectorRef to update the component on change
     * @param {SettingsService} settingsService SettingsService has settings we need.
     * @param {ExecutorsService} executorsService ExecutorsService needed for drag/drop actions.
     * @param {DomainService} domainService DomainService to get the shifts and services.
     */
    function PluginViewAttendantsComponent(alertsService, localisationService, changeDetector, eventsService, settingsService, ngZone, executorsService, domainService, elementRef, gridService) {
        var _this = _super.call(this, alertsService, localisationService, changeDetector, eventsService, settingsService, executorsService, domainService, elementRef, ngZone, gridService) || this;
        _this.alertsService = alertsService;
        _this.domainService = domainService;
        _this.elementRef = elementRef;
        _this.gridService = gridService;
        /**
         * Need generated data
         */
        _this._generated = false;
        return _this;
    }
    Object.defineProperty(PluginViewAttendantsComponent.prototype, "useExecutor", {
        /**
         * Sets the executor that will be used
         * @param {ExecutorName} value
         */
        set: function (value) {
            if (!value) {
                throw new Error('Exector Not found');
            }
            this.executorName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginViewAttendantsComponent.prototype, "generated", {
        get: function () {
            return this._generated;
        },
        /**
         * Set generated to true
         * @param {boolean} value
         */
        set: function (value) {
            if (!value) {
                throw new Error('Generated not set');
            }
            this._generated = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the include query parameter value.
     * @protected
     * @returns The include query parameter value.
     */
    PluginViewAttendantsComponent.prototype.getIncludeOfTasklist = function () {
        var useGenerated = '';
        if (!this.generated) {
            useGenerated = '!';
        }
        if (!this._selectedFunction) {
            return "Attendants UNPLANNED " + useGenerated + "PURPOSES[GENERATED]";
        }
        return "Attendants UNPLANNED CONCERNS[" + this._selectedFunction['Oid'] + "] " + useGenerated + "PURPOSES[GENERATED]";
    };
    return PluginViewAttendantsComponent;
}(PluginViewShiftsComponent));
export { PluginViewAttendantsComponent };
